// Auto-generated from Enums folder

export enum AggregationType {
    None = 1,
    Count = 2,
    Sum = 3,
    Average = 4,
    Max = 5,
    Min = 6
}

export enum ConverterType {
    None = 0,
    RoundNumber = 1,
    LocalDate = 2,
    LocalTime = 3
}

export enum DynamicControlType {
    Custom = 1,
    Textbox = 2,
    DropDown = 3,
    AutoComplete = 4,
    Checkbox = 5,
    CheckboxGroup = 6,
    RadioButton = 7
}

export enum FavoriteType {
    App = 1,
    Report = 2,
    Dashboard = 3
}

export enum LayoutTemplate {
    SingleColumn = 0,
    TwoColumn = 1,
    ThreeColumn = 2,
    OneByTwoColumn = 3
}

export enum NavigationType {
    Role = 1,
    Company = 2,
    All = 3
}

export enum ReportType {
    Table = 0,
    Chart = 1,
    Rdlc = 2,
    Widget = 3,
    View = 4
}

export enum Size {
    None = 0,
    Mini = 1,
    Medium = 2,
    Large = 3,
    ExtraLarge = 4,
    Auto = 5,
    Popin = 6
}
